import { AfterViewChecked, Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from 'ng2-toastr';
import { TransitionService } from '@uirouter/core';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { LocaleService } from '@ngx-ivengi/locale';
import { StateService } from '@uirouter/angular';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit, AfterViewChecked {
  public currentLanguage: string;
  public availableLanguages: string[] = [];
  private isScriptingInitialized = false;

  constructor(
    private localeService: LocaleService,
    private stateService: StateService,
    private translateService: TranslateService,
    protected $transitions: TransitionService,
    private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
    public toast: ToastsManager,
    public vcr: ViewContainerRef,
    private titleService: Title,
    private metaService: Meta,
    @Inject('WINDOW') private window: any
  ) {
    toast.setRootViewContainerRef(vcr);

    $transitions.onSuccess({}, () => {
      window.scroll(0, 0);
    });
  }

  ngOnInit(): void {
    this.initLangNav();

    this.translateService.get('shop.intro.page-title').subscribe((title: string) => {
      this.titleService.setTitle(title);
    });
    this.translateService.get('shop.intro.content-block-left').subscribe((metadescription: string) => {
      this.metaService.addTag({ name: 'description', content: metadescription });
    });
  }

  ngAfterViewChecked(): void {
    if (!this.isScriptingInitialized) {
      this.isScriptingInitialized = true;

      this.window.templateScripting.init();
      this.window.mobileNavigation.init();
      this.window.stickyHeader.init();
    }
  }

  private initLangNav(): void {
    this.currentLanguage = LocaleService.getCurrentLanguageISO();
    this.availableLanguages = LocaleService.getAvailableLanguageISO();
  }

  public changeLang(language: string): void {
    this.localeService.setCurrentLanguageISO(language);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/app.component.ts